import { ErrorCard } from './ErrorCard';

export default ErrorCard;
